<template>
  <div>
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header> 

    <el-main v-loading.fullscreen.lock="loading" style="overflow-x: hidden;">
      <el-form ref="form" label-width="120px" >
          <el-row>
            <el-col :span="14">
              <el-form-item :label="$t('field.shippingDate')">
                <el-col :span="12">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdate" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="10">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="edate" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('field.invoiceNo')"><el-input v-model="invoiceNo"></el-input></el-form-item>
            </el-col>        
          </el-row>    
          <el-row>
            <el-col :span="7">
              <el-form-item :label="$t('field.isReceive')">
                <el-select v-model="isReceive" style="width:100%" :placeholder="$t('msg.pleaseSelect')" :clearable="true">
                  <el-option v-for="item in isReceiveOpts"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>  
            <el-col :span="10">
              <CustomerSearch v-if="!isCustomer" v-model="custSapCode"  @sync-select-customer="syncSelectCustomer" /> 
            </el-col>         
          </el-row> 
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>
              <el-button type="primary" @click="confirmAll"  size="small">{{$t('button.confirmAllReceived')}}</el-button>
            </el-col>             
          </el-row>
        </el-form>
      <el-row >  
        <Table ref="resultTable" :tableData.sync="tableData" :checkAction="checkAction"/> 
      </el-row>
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue'
import Table from '../components/FuzzySearchTable'
import CustomerSearch from "../components/CustomerSearch";

import { apiFindShippingAndReceive, apiUpdShippingReceiveTime  } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";

export default {
  name: 'productList',
  data() {   
    return {     
      loading:false,
      sdate: '',
      edate: '',
      invoiceNo: '',
      isReceive: '',
      isReceiveOpts: [ {label:'Received 已收貨',value:'Y'},{label:'Not yet received 未收貨', value:'N'}],  
      tableData: {
        sel: null,
        columns: [
          
          { field:'shipToName', title: this.$i18n.t('field.customerNo')},
          { field:'invoiceNo', title: this.$i18n.t('field.invoiceNo'), width: 130},
          { field:'serialNo', title: 'Serial No.', width: 150},
          { field:'custSerialNo', title: 'Customer Serial No.', width: 190},
          { field:'model', title: 'Model', width: 140},
          { field:'modelName', title: 'Model Name', width: 140 },
          { field:'shippingDate', title: this.$i18n.t('field.shippingDate'), width: 150, align:'center'  },
          { field:'receiveTime', title:  this.$i18n.t('field.receiveTime'), width: 150, checkbox : true, align:'center', tooltip: this.$i18n.t('field.received' ) }
        ],  
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'shippingDataTable',
        exportName: this.$i18n.t('menu.shippingData')
      },
      isCustomer:false,
      custSapCode:''
    };
  },   
  components: {
    Breadcrumb,
    Table ,
    CustomerSearch
  },
  created(){
    this.isCustomer = this.$store.state.auth.user.username.indexOf('@')>-1 ? true : false;      
  },
  mounted() {
  },
  methods: {
    readData(){
      this.loading = true;
      this.tableData.data = [];
      this.tableData.originalTableData =  [];  
      var sdate = '', edate = '';
      if(this.sdate != null && this.sdate != ''){        
        sdate = CommonUtil.dateFormatDate(this.sdate);
      }
      if(this.edate != null && this.edate != ''){        
        edate = CommonUtil.dateFormatDate(this.edate);
      }

      apiFindShippingAndReceive({ headers: authHeader(),custSapCode:this.custSapCode, invoiceNo: this.invoiceNo, isReceive:this.isReceive, 
          sdate:sdate, edate: edate }).then((response) => {        
         response.data.forEach((item, index) => {
          if(item.shippingDate != null && item.shippingDate != '' && item.shippingDate.length > 11){
            item.shippingDate = item.shippingDate.substring(0,10);            
          }  
          if(item.receiveTime != null && item.receiveTime != ''){
              item.receiveTime = CommonUtil.dateFormat(new Date(item.receiveTime));
          }        
        });    
        this.tableData.data = response.data;       
        this.tableData.originalTableData =  this.tableData.data;  
      
        this.loading = false;
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    },
    search(){
      var invoiceNo = this.invoiceNo;
      var sdate = this.sdate;
      var edate = this.edate;
      var isReceive = this.isReceive;
      var custSapCode = this.custSapCode;
      
      //是否要卡incx員工一定要填
      if(!this.isCustomer && (custSapCode == null || custSapCode == '' )){
        return this.$message.warning({message: this.$i18n.t('field.customerNo')+' '+this.$i18n.t('msg.fieldNotEmpty'), duration: 800});
      }
      if((invoiceNo == null || invoiceNo == '') && (sdate == null || sdate == '')  && (edate == null || edate == '') && (isReceive == null || isReceive == '')  ){
        return this.$message.warning({message: this.$i18n.t('msg.selectOneAtleast'), duration: 800});
      }      
      this.readData();      
    },
    checkAction(row, index, check){
      let cnt = 0;
      let ids = '',serialNos = '';

      const tableData = this.$refs.resultTable.tableData.data;
      row['check'] = check;
      tableData.forEach((item, index) => {
        if(item['check'] == true){
          ids = ids + item.id + ',';
          serialNos = serialNos + item.serialNo + ', ';
          cnt++;
        }
      });  
      if( serialNos != null && serialNos != '' &&  serialNos.substring(serialNos.length-2, serialNos.length-1) == ','){
        serialNos = serialNos.substring(0, serialNos.length-2);
      }       
      serialNos = (serialNos ==null || serialNos == 'null' ? '' : serialNos);
      const msg = this.$i18n.t('msg.sendReceiveTime').replace('{serialNo}', serialNos).replace('{cnt}', cnt);      
      this.$confirm(msg, {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        this.sendReceiveTime(ids);
        done();
      }).catch(_ => {});   
      
    },    
    confirmAll(){
      const tableData = this.$refs.resultTable.tableData.data;
      let ids = '',serialNos = '';
      var cnt = 0;
      tableData.forEach((item, index) => {
        if(item['receiveTime'] == null || item['receiveTime'] == ''){
          ids = ids + item.id + ',';
          var tempSn = ( item.serialNo ==null || item.serialNo == 'null' ? '' : item.serialNo)
          serialNos = serialNos + tempSn + ', ';
          cnt++;
        }
      });  
      
      if(cnt == 0){
        this.$message({ type: "error", message: this.$i18n.t('msg.noDataFound'), duration: 800});
      } else {
        if( serialNos != null && serialNos != '' && serialNos.substring(serialNos.length-2, serialNos.length-1) == ','){
          serialNos = serialNos.substring(0, serialNos.length-2);
        }   
        serialNos = (serialNos ==null || serialNos == 'null' ? '' : serialNos);
        const msg = '<div style="height: 300px;overflow: auto;">' +
                    this.$i18n.t('msg.sendReceiveTime').replace('{serialNo}', serialNos).replace('{cnt}', cnt) +'</div>' ;

        
    
        this.$confirm(msg, {        
          confirmButtonText: this.$i18n.t('button.confirm'),
          cancelButtonText: this.$i18n.t('button.cancel'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(_ => {       
          this.sendReceiveTime(ids); 
          done();
        }).catch(_ => {});  
      }       
    },
    syncSelectCustomer(custNo){            
      this.custSapCode = custNo;
    }, 
    sendReceiveTime(ids){
      this.loading = true;
      apiUpdShippingReceiveTime({ headers: authHeader(), id:ids }).then((response) => {        
        if(response.status == 200){
          this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});     
          this.readData();
        }else{
          this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      });
    },   
  }
};
</script>
